import React, { useEffect } from 'react';

 
 
const handleGetBrowserName = () => {
    var ua = navigator.userAgent;
    var tem;
    var M =
      ua.match(
        /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
      ) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);

    return M[0]; //.join(" ");
  };
  const CurrentBrowser=handleGetBrowserName();

const SmartAppBanner = () => {
    const isProduction = process.env.REACT_APP_NODE_ENV === "production";
    const isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      const isAndroid = navigator.userAgent.toLowerCase().includes("android");

  
    // Conditionally set the path based on the environment
    const imagePath = isProduction
      ? window.location.hostname.includes("localhost")
        ? "../"
        : "https://www.directmortgage.com/R/"
      : "../";

    useEffect(() => {
        
        const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);

      
        if ( isIOS || isAndroid) {
            // Display smart app banner for iOS
            const banner = document.createElement('div');
            banner.innerHTML =  `<div id="smartAppBanner" style=" fontFamily:'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif;background-color: #007bff; color: rgb(100, 100, 100); padding: 10px; text-align: center;    top: 0px; position: fixed;width: 100%;z-index:9999;background: linear-gradient(rgb(246, 246, 246) 0%, rgb(232, 232, 232) 100%);box-shadow: rgba(0, 0, 0, 0.25) 0px 6px 20px;">
                    <img src="${imagePath}AppLogo.png" alt="App Logo" style="width: 70px; height: 70px; margin-right: 10px;float:left;  border-radius: 10px;">
                    <div style="flex-grow: 1;float:left">
                        <span style="font-size: 18px;float:left;  font-weight:bold">Go Direct Mortgage App</span><br/>
                        <span style="font-size: 18px;float:left">Use our mobile app.</span>
                    </div>
                    <button style="background: rgb(70, 128, 225);color:white; border: 1px solid rgb(81, 97, 125); border: none; padding: 5px 10px; margin-left: 10px; border-radius: 5px; cursor: pointer;margin-top:20px">Install</button>
                    <button id="closeButton" style="position: absolute; top: 0px; right: 5px; background-color: transparent; border: none; padding: 5px; cursor: pointer;font-size:25px;margin-top: -5px; color: rgb(100, 100, 100);">&times;</button>
                </div>`;

            banner.querySelector('#closeButton').addEventListener('click', () => {
                // Close the banner when close button is clicked
                banner.remove();
            });
            banner.addEventListener('click', (event) => {
                // Close the banner when anywhere on the banner is clicked except the close button
                if (event.target.id === 'smartAppBanner') {
                    banner.remove();
                }
            });
            banner.querySelector('button').addEventListener('click', () => {

                // const appScheme = 'com.directcorp.godirectmortgage://?param1=1'
                // const appStoreURL = 'https://apps.apple.com/us/app/go-direct-mortgage/id6458930558?platform=iphone' // iOS App Store URL
                // const playStoreURL =  'https://play.google.com/store/apps/details?id=com.directcorp.godirectmortgage' // Google Play Store URL

                
                // // Redirect users to the App Store
                // const start = Date.now();
                // const timeout = 3000; // 1 second

                // // Try to open the app using the custom URL scheme
                // window.location = appScheme;

                // setTimeout(() => {
                //     // If the time difference is less than the timeout, assume the app is not installed
                //     if (Date.now() - start < timeout + 100) {
                //         if (/android/i.test(navigator.userAgent)) {
                //             window.location = playStoreURL;
                //         } else if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
                //             window.location = appStoreURL;
                //         } else {
                //             // Default fallback if the platform cannot be detected
                //             window.location = appStoreURL;
                //         }
                //     }
                // }, timeout);


                // return;
                if (isIOS)
                    window.location.href = 'https://apps.apple.com/us/app/go-direct-mortgage/id6458930558?platform=iphone';
             
            
                if(isAndroid)
                    window.location.href = 'https://play.google.com/store/apps/details?id=com.directcorp.godirectmortgage';
            });
            document.body.appendChild(banner);
           
        }
    }, []);

  

    return null; // Since this component only handles side effects, it doesn't render anything
};

export default SmartAppBanner;

